import { css } from 'linaria';

export const deliveryInfo = css`
  margin: var(--space-250) 0 var(--space-150);
`;

export const deliveryInfoText = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--space-75);
`;
